import { getValueByKey } from '@common/utils/component';
import { RootState } from '../store';
import { appInfoSelector } from '@common/redux/selectors/app';
import { Platform } from 'click-types';
import { getMetadataScreenByResponsive } from '@common/utils/screen';
import { IPage } from '@common/types/element';
import { cloneDeep } from 'lodash';

export const dimensionSelector = (state: RootState) => state.pageInfo.dimension;
export const pagesSelector = (state: RootState) => {
  const dimension = dimensionSelector(state);
  const platform = appInfoSelector(state)?.platform;
  const pages = state.pageInfo.pages;
  if (platform === Platform.RESPONSIVE) {
    const newPages: { [key: string]: IPage } = {};
    Object.keys(pages).forEach((pageId) => {
      const page = pages[pageId];
      const metadata = getMetadataScreenByResponsive(
        cloneDeep(page),
        dimension
      );
      newPages[pageId] = {
        ...page,
        ...metadata,
        metadata: metadata.children ?? [],
      };
    });
    return newPages;
  }
  return pages;
};

export const googleMaploaded = (state: RootState) =>
  state.pageInfo.googleMaploaded;

export const valueBindingPageSelector = (state: RootState) =>
  state.pageInfo.valueBindingScreen;

export const simpleBindingSelector =
  (componentId: string) => (state: RootState) =>
    getValueByKey(valueBindingPageSelector(state), componentId);

export const loadingPageSelector = (state: RootState) =>
  state.pageInfo.loadingPage;

export const showQrCodeSelector = (state: RootState) =>
  state.pageInfo.qrCodeScanner;
export const showQrCodeStatusSelector = (state: RootState) =>
  state.pageInfo.qrCodeScanner.status;
export const showQrCodeValueSelector = (state: RootState) =>
  state.pageInfo.qrCodeScanner.qrCode;

export const bindingLoaderSelector = (state: RootState) =>
  state.pageInfo.bindingLoader;

export const pullToRefreshSelector = (state: RootState) =>
  state.pageInfo.pullToRefresh;
